/* Built In Imports */
import { forwardRef, useState } from 'react';

/* External Imports */
import {
  Box,
  Button,
  FormControl,
  Grid,
  Link,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  useMultiStyleConfig,
  useTab
} from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { useMediaQuery } from 'react-responsive';

/* Internal Imports */
/* Components */
import MidContainer from '@Layout/MidContainer';
import SingleImage from '@components/Card/SingleImage';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { refineUrlDomain } from '@components/Utility/utils';
import config from '@config';
import SannidhiSectionTitle from '@landing_pages/sadhgurusannidhi/SannidhiSectionTitle';

/* Services */

/**
 *
 * @param {object} section
 * @returns ProgramDetails
 */

const ProgramTabSection = ({ section, region, lang, styling, csrData }) => {
  // console.log('tab', section);
  // console.log('geo1', csrData);
  let tabActive = false;
  const isMobile = useMediaQuery({ maxWidth: 320 });

  const [prgUrl, setPrgUrl] = useState('');
  const [prgPrice, setPrgPrice] = useState('');
  const [prgCurrency, setprgCurrency] = useState('');
  const sectionContent = section;
  let prgm_reg_url = '';
  let prgm_price = '';
  let prgm_currency = '';
  let prgm_regn_allowed = '';
  let prgm_regn_message = '';
  let price_label_hide = '';
  if (csrData) {
    prgm_regn_allowed = csrData?.result[0]?.is_registration_allowed;
    if (csrData?.result[0]?.is_registration_allowed == true) {
      prgm_reg_url = csrData?.result[0]?.url_enquiry;
      prgm_price = csrData?.result[0]?.tickets[0]?.price;
      prgm_currency = csrData?.result[0]?.tickets[0]?.currency;
      prgm_regn_message = csrData?.result[0]?.regional_notes;
    } else if (csrData?.result[0]?.is_registration_allowed == false) {
      prgm_reg_url = csrData?.result[0].url_enquiry;
      price_label_hide = true;
      prgm_price = '';
      prgm_currency = '';
    } else {
      price_label_hide = true;
    }
  }
  // console.log('prgmurl', prgm_reg_url, prgm_price, prgm_regn_allowed);

  const CustomTab = forwardRef((props, ref, csrData) => {
    // 1. Reuse the `useTab` hook
    const tabProps = useTab({ ...props, ref });

    const isSelected = !!tabProps['aria-selected'];

    // 2. Hook into the Tabs `size`, `variant`, props
    const styles = useMultiStyleConfig('Tabs', tabProps);
    const Arrow = () => {
      return (
        <Box
          as="span"
          position="absolute"
          width="20px"
          display={isSelected ? 'block' : 'none'}
          height="11px"
          clipPath="polygon(0 0, 50% 100%, 100% 0)"
          left="50%"
          bottom="-10px"
          background="#CF4520"
          style={{ transition: 'width 1s' }}
          zIndex="0"
          transition="0.4s linear"
        ></Box>
      );
    };

    return (
      <Button
        __css={styles.tab}
        {...tabProps}
        width="50%"
        color={isSelected ? '#FFFFFF !important' : '#656564  !important'}
        bg={isSelected ? '#CF4520' : '#ECECEC'}
        border="0"
        fontFamily="FedraSansStd-book"
        fontStyle="normal"
        fontWeight="600"
        fontSize={{ base: '14px', sm: '14px', md: '22px' }}
        lineHeight="150.3%"
        _active={{ bg: '#CF4520', border: '0' }}
        _focus={{ bg: '#CF4520', border: '0' }}
        pos="relative"
        height={{ base: '50px', sm: '72px' }}
        p={{ base: '0', sm: '1rem' }}
      >
        {isSelected ? <Arrow /> : ''}
        {tabProps.children}
      </Button>
    );
  });

  let paramLang = config.allLang.indexOf(lang) > -1 ? `/${lang}/` : '';

  const dataLayerPush = eName => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eName,
    });
  };

  return (
    <Box
      id="program-details"
      bgColor="#EDE8DE"
      pt={{ base: '30px', md: '40px' }}
      mb={{ base: '40px', sm: '40px', md: '20px' }}
    >
      <SannidhiSectionTitle titleObj={sectionContent[0]} />
      <SingleImage
        sectionContent={sectionContent[1]}
        region={region}
        lang={lang}
        my="8"
      />
      <Box width={{ base: '100%', md: '754px' }} m="0 auto">
        <StructuredTextParser
          str={render(sectionContent[2].body)}
          region={region}
          lang={lang}
          className="generaltext"
          w={{ base: '93%', md: '100%' }}
          m={{ base: '0 auto' }}
          fontSize="16px"
          lineHeight="24px"
          mt="0"
        />
      </Box>

      <Box
        w={{ base: '95%', md: '652px' }}
        maxW="1170px"
        m={{ base: '20px auto 0', md: '20px auto' }}
        pl="0"
        pr="0"
        pb="0"
        id="program-type"
      >
        <Tabs
          isFitted
          variant="enclosed"
          p="0"
          className="tabcontent"
          border={{
            base: 'none',
            md: 'none'
          }}
          borderRadius="12px"
          paddingBottom="20px"
          defaultIndex={csrData && prgm_regn_allowed == 'false' ? 1 : 0}
        >
          <TabList borderBottom="none">
            <CustomTab
              style={{ borderRadius: '10px 0 0 0' }}
              tabIndex="1"
            // bgColor="#ffffff"
            >
              {sectionContent[3]?.titleText}
            </CustomTab>
            <CustomTab
              style={{ borderRadius: '0 10px 0 0' }}
              tabIndex="2"
            // bgColor="#ffffff"
            >
              {sectionContent[9]?.titleText}
            </CustomTab>
          </TabList>

          <TabPanels m="0 auto" maxW="652px">
            <TabPanel bgColor="#ffffff" p="0">
              <Box
                bgImage={`${config.imgPath}/d/46272/1681834311-bg_sannidhi.png`}
                backgroundRepeat="no-repeat"
                backgroundPosition={
                  isMobile
                    ? '50% 71%'
                    : { base: '50% 91%', sm: '50% 91%', md: '45% 87%' }
                }
                backgroundSize={{ base: '64%', md: 'auto' }}
                pt="10px"
              >
                <SingleImage
                  sectionContent={sectionContent[5]}
                  region={region}
                  lang={lang}
                />
                <StructuredTextParser
                  className={sectionContent.fieldId}
                  str={render(sectionContent[4].body)}
                  region={region}
                  lang={lang}
                />
                <Grid
                  placeItems="center"
                  placeContent="center"
                  width="auto"
                  mx="auto"
                >
                  <FormControl>
                    {sectionContent[6]?.data?.map((data, i) => {
                      i++;
                      return (
                        <>
                          {/* {data.Value == '[price]' && prgm_price != '' && ( */}
                          <Box
                            display="flex"
                            width={{ base: '90%', sm: '90%', md: '100%' }}
                            fontFamily="FedraSansStd-book"
                            fontStyle="normal"
                            fontWeight="500"
                            fontSize={{ base: '14px', md: '16px' }}
                            lineHeight={data.Label != '' ? '22.4px' : '0'}
                            py={{ base: '15px', md: '13px' }}
                            mx={{ base: '15px' }}
                            borderBottom={{
                              base: '0.5px solid #483C1B',
                              md: 'none',
                            }}
                            _last={{ borderBottom: 'none !important' }}
                            pr={{ base: '15px', md: '10px' }}
                            alignItems="center"
                          >
                            <Box
                              display="inline-block"
                              width="50%"
                              color="#818181"
                              verticalAlign="top"
                              pl={{ base: '10px', sm: '10px', md: '70px' }}
                              pr={{ base: '5px', sm: '5px', md: '62px' }}
                              fontFamily="FedraSerifAStdBook"
                            >
                              {csrData &&
                                price_label_hide == true &&
                                data.Label == 'Price*'
                                ? ''
                                : data.Label}
                            </Box>
                            <Box
                              display="inline-block"
                              width="50%"
                              maxW={{ base: '50%', md: '40%' }}
                              color="#000"
                              textAlign={{ base: 'center', md: 'left' }}
                              pl={{ base: '16px', md: '0' }}
                              pr={{ base: '60x', md: '40px' }}
                            >
                              {data.Value == '[yes]' ? (
                                <LazyLoadImageComponent
                                  src={`${config.staticPath}/d/46272/1681957315-orange-tick.png`}
                                  alt="green check"
                                  title="green check"
                                />
                              ) : (
                                <>
                                  {data.Value == '[price]' ? (
                                    <>
                                      {csrData != '' &&
                                        csrData.result[0]
                                          ?.is_registration_allowed && (
                                          <>
                                            <Text fontWeight="bold">
                                              {prgm_currency} {prgm_price}
                                            </Text>
                                          </>
                                        )}
                                    </>
                                  ) : (
                                    <>{data.Value}</>
                                  )}
                                </>
                              )}
                            </Box>
                          </Box>
                          {/* )} */}
                        </>
                      );
                    })}
                  </FormControl>
                </Grid>
              </Box>
              <MidContainer w={'768'} bgColor="#EDE8DE">
                {csrData != '' &&
                  prgm_regn_allowed == true &&
                  prgm_regn_message != '' && (
                    <Text
                      mt="35px"
                      p="35px 20px 0 20px"
                      textAlign={{ base: 'left', md: 'center' }}
                      fontSize="16px"
                    >
                      <Text as="span" fontWeight="bold">
                        {sectionContent[17]?.text}
                      </Text>{' '}
                      {prgm_regn_message}
                    </Text>
                  )}
                {csrData != '' && prgm_regn_allowed == false && (
                  <>
                    <StructuredTextParser
                      str={render(sectionContent[16]?.body)}
                      region={region}
                      lang={lang}
                      mt="35px"
                      p="35px 20px 0 20px"
                      textAlign={{ base: 'left', md: 'center' }}
                      fontSize="16px"
                    />
                  </>
                )}
                {sectionContent[8]?._modelApiKey === 'simple_button' && (
                  <Box display="flex" placeContent="center" pt="40px">
                    <Link
                      // href={refineUrlDomain(prgm_reg_url, region, lang)}
                      href={refineUrlDomain(sectionContent[8]?.linkUrl, region, lang)}
                      mb="30px"
                      display="block"
                      fontWeight={'500'}
                      fontFamily={'FedraSansStd-medium'}
                      fontSize={'18px'}
                      bgColor={sectionContent[8]?.linkUrl ? '#cf4520' : '#cf452069'}
                      h={'auto'}
                      minH="50px"
                      textAlign="left"
                      padding={'14px 29px'}
                      borderRadius="5px"
                      color="#faf7f0"
                      textDecoration="none"
                      width={'auto'}
                      cursor={sectionContent[8]?.linkUrl ? 'pointer' : 'not-allowed'}
                      _hover={{
                        bg: sectionContent[8]?.linkUrl ? '#000054' : '',
                      }}
                      target={sectionContent[8]?.linkUrl ? '_blank' : ''}
                    >
                      {sectionContent[8]?.buttonText}
                    </Link>
                  </Box>
                )}
              </MidContainer>
            </TabPanel>

            <TabPanel bgColor="#fff" p="0">
              <Box
                bgImage={`${config.imgPath}/d/46272/1681834311-bg_sannidhi.png`}
                backgroundRepeat="no-repeat"
                backgroundPosition={
                  isMobile
                    ? '50% 63%'
                    : {
                      base: '50% 91%',
                      sm: '50% 50%',
                      md: '45% 87%',
                    }
                }
                backgroundSize={{ base: '64%', sm: '60%', md: 'auto' }}
              >
                <Box
                  className="Inperson-details"
                  display="flex"
                  justifyContent="center"
                  pt="20px"
                  px="5%"
                  fontFamily="FedraSansStd-book"
                  fontSize={{ base: '14px', md: '14px' }}
                  lineHeight="190%"
                >
                  {sectionContent[10].fieldId != 'Inperson-details-hide' && (
                    <StructuredTextParser
                      className={sectionContent.fieldId}
                      str={render(sectionContent[10].body)}
                      region={region}
                      lang={lang}
                      fontSize={{ base: '14px', md: '14px' }}
                    />
                  )}
                </Box>
                <SingleImage
                  sectionContent={sectionContent[11]}
                  region={region}
                  lang={lang}
                />
                <Grid
                  placeItems="center"
                  placeContent="center"
                  width="auto"
                  mx="auto"
                >
                  <FormControl>
                    {sectionContent[13]?.data?.map((data, i) => {
                      return (
                        <>
                          <Box
                            display="flex"
                            width="100%"
                            fontFamily="FedraSansStd-book"
                            fontStyle="normal"
                            fontWeight="500"
                            fontSize={{ base: '14px', md: '16px' }}
                            lineHeight="22.4px"
                            py={{ base: '15px', md: '13px' }}
                            borderBottom={{
                              base: '0.5px solid #483C1B',
                              md: 'none',
                            }}
                            _last={{ borderBottom: 'none !important' }}
                            pr={{ base: '15px', md: '10px' }}
                            alignItems="center"
                          >
                            <Box
                              display="inline-flex"
                              width="55%"
                              color="#818181"
                              verticalAlign="top"
                              pl={{ base: '10px', sm: '10px', md: '70px' }}
                              pr={{ base: '5px', sm: '5px', md: '110px' }}
                              fontFamily="FedraSerifAStdBook"
                            >
                              {data.Label}
                            </Box>
                            <Box
                              display="inline-block"
                              width="45%"
                              color="#000"
                              textAlign={{ base: 'center', md: 'left' }}
                              verticalAlign="top"
                              pl={{ base: '16px', md: '0' }}
                              pr={{ base: '60x', md: '0' }}
                            >
                              {data.Value == '[yes]' ? (
                                <LazyLoadImageComponent
                                  src={`${config.staticPath}/d/46272/1681957315-orange-tick.png`}
                                  alt="green check"
                                  title="green check"
                                />
                              ) : (
                                <>
                                  {data.Label == 'Price*' ? (
                                    <>
                                      <Text fontWeight="bold">
                                        {data.Value}
                                      </Text>
                                    </>
                                  ) : (
                                    <>{data.Value}</>
                                  )}
                                </>
                              )}
                            </Box>
                          </Box>
                        </>
                      );
                    })}
                  </FormControl>
                </Grid>
              </Box>
              <MidContainer w={'768'} bgColor="#EDE8DE">
                <StructuredTextParser
                  str={render(sectionContent[14].body)}
                  region={region}
                  lang={lang}
                  mt="20px"
                  pt="20px"
                  className="programDetailsText"
                  textAlign="center"
                  fontSize="16px"
                />
                {sectionContent[15]?._modelApiKey === 'simple_button' && (
                  <Box display="flex" placeContent="center" mt="40px">
                    <Link
                      href={refineUrlDomain(
                        sectionContent[15].linkUrl,
                        region,
                        lang
                      )}
                      mb="30px"
                      display="block"
                      fontWeight={'500'}
                      fontFamily={'FedraSansStd-medium'}
                      fontSize={'18px'}
                      bgColor={
                        sectionContent[15].linkUrl ? '#cf4520' : '#cf452069'
                      }
                      h={'auto'}
                      minH="50px"
                      textAlign="left"
                      padding={'14px 29px'}
                      borderRadius="5px"
                      color="#faf7f0"
                      textDecoration="none"
                      width={'auto'}
                      cursor={
                        sectionContent[15].linkUrl ? 'pointer' : 'not-allowed'
                      }
                      _hover={{
                        bg: sectionContent[15].linkUrl ? '#000054' : '',
                      }}
                      target={sectionContent[15].linkUrl ? '_blank' : ''}
                    >
                      {sectionContent[15]?.buttonText}
                    </Link>
                  </Box>
                )}
              </MidContainer>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
      <style>
        {`
        .Inperson-details mark {
          color: #cf4520;
          background: transparent;
        }
        .Inperson-details p:first-child::before{
          content:url('https://static.sadhguru.org/d/46272/1681927185-icon_location.png'); 
          position:relative;
          left: -10px;
          top: 2px;
          padding-left: 0px;
        }
        .Inperson-details p:nth-child(2)::before{
          content:url('https://static.sadhguru.org/d/46272/1681927258-icon_check-in.png'); 
          position:relative;
          left: -10px;
          top: 2px;
          padding-left: 0px;
          
        }
        .Inperson-details p:nth-child(3)::before{
          content:url('https://static.sadhguru.org/d/46272/1681927258-icon_check-in.png'); 
          position:relative;
          left: -10px;
          top: 2px;
          padding-left: 0px;
          
        }
        .generaltext p mark {
          background: transparent;
          font-size: 14px;
        }
        .generaltext p {
          line-height: 24px;
          padding: 10px 0;
          font-size:16px;
        }
        .programDetailsText p{
            font-size:16px;
          }
          @media screen and (max-width: 450px) {
            .programDetailsText{
              text-align:left;
            }
            .generaltext p:nth-child(1) {
              padding-top: 0px;
            }
            .programDetailsText p{
              font-size:14px !important;
            }
            .programDetailsText strong{
              font-size:14px !important;
            }
          }
          @media only screen and (max-width: 360px) {
            .gridComponent {
                grid-template-columns: repeat(1, minmax(0, 1fr));
                margin-top: 10px;
            }
          }
        `}
      </style>
    </Box>
  );
};

export default ProgramTabSection;
